<template>
	<div class="signup-container">
		<button class="email-signup btn" v-tooltip="{ content: content.emailSignup.toolTip }" @click="showSignup"
			data-tour-item="emailSignup" v-bind="config.attrs" tabindex="0">
			<!--		<span class="signup-text">{{ content.emailSignup }}</span>
		<img class="email-icon" src="/icons/icon-mail.svg" />-->
			<svg role="img" :title="content.emailSignup.label"  aria-labelledby="emailSignup" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#"
				xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg"
				xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" width="22px" height="24px"
				viewBox="0 4 32 24" xml:space="preserve">
				<path id="path3040" fill="#545454"
					d="M 0,4 V 28 H 32 V 4 H 0 z M 28.149,6 15.998,15.719 3.851,6 H 28.149 z M 2,25.999 V 7.081 L 15.998,18.278 29.999,7.081 V 25.999 H 2 z" />
			</svg>
			<span class="panel-label">{{ content.emailSignup.label }}</span>

		</button>
		<span class="separator-right"></span>
	</div>
</template>

<script>

import { mapActions, mapGetters } from "vuex";
import featureMixin from "@/mixins/featureMixin";
import Lytics from "../../classes/Lytics";
//import ParentComms from "@/classes/ParentComms";

export default {
	name: "emailSignupButtonV2",
	mixins: [featureMixin],
	data() {
		return {
			featurePath: 'emailSignup',
			featureEvents: ['iframe-event-emailSignupClosed'],
			triggerEl: null
		}
	},
	computed: {
		...mapGetters(['content'])
	},
	methods: {
		...mapActions('events', ['triggerEvent']),
		showSignup(event) {
			this.triggerEl = event.currentTarget;
			this.triggerEvent({ event: 'emailSignUp' })
			Lytics.TriggerEmailSignupClick();
		},
		onFeatureEvent(event) {
			if (event === 'iframe-event-emailSignupClosed') {
				this.triggerEl?.focus();
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.signup-container {
	display: inline-flex;

	button.email-signup {
		margin-left: 10px;
		padding: 0;
    background: none;

		svg {
			width: 22px;
		}
    svg path {
      fill: var(--secondary-color);
    }

		span {
			font-size: 14px;
      color: var(--secondary-color);
		}
	}
}
</style>
